<template>
  <div>
    <v-toolbar flat color="transparent" class="clinicSelectorbar">
        <clinic-selector-dropdown :selectedClinic.sync="selectedClinic" @change="handleClinicChange(this.selectedClinic)" />
      </v-toolbar>
      <template v-if="selectedClinic">
        <div>
          <manage-messaging-services :selected-clinic="selectedClinic" />
          <manage-phone-numbers :selected-clinic="selectedClinic" />
        </div>
      </template>
      <template v-if="!selectedClinic">
        <div class="clinicSelectionMessage">
          <h2>Please select a clinic to manage services</h2>
        </div>
      </template>
  </div>
</template>

<script>
  /* eslint-disable */
import ManageMessagingServices from "../../../../entities/messaging-service/manage-messaging-services/manage-messaging-services.vue";
import ManagePhoneNumbers from "../../../../entities/messaging-service/manage-phone-numbers/manage-phone-numbers.vue";
import ClinicSelectorDropdown from "../../entities/clinic/clinic-selector-dropdown/clinic-selector-dropdown.vue";

export default {
  name: "ManageMessagingServicesPage",
  components: {
    ManagePhoneNumbers,
    ManageMessagingServices,
    ClinicSelectorDropdown
},
  data: () => ({
    selectedClinic: null,
    methods: {
      async handleClinicChange(practice) {
        //alert(practice.value);
        //alert(this.$store.state.posActivePractice.value);
      }
    }
  }),
};
</script>

<style lang="scss" scoped>
.clinicSelectorbar {
  margin-bottom: 2rem;
  margin-top: 1rem;
  display: flex !important;
  justify-content: flex-end !important;
}
.clinicSelectionMessage {
  display: flex;
  justify-content: center;
  align-items: center;
  h2 {
    color: rgb(139, 139, 139);
  }
}
</style>
